/**
 * Whether a form response is a note rather than a form submission, and should be shown, filtered, and
 * hidden from patients as one. Decided by the response alone: `isInternalNote` is stamped at creation
 * (for example when a `type: "note"` form is submitted through the Note compose tab), so a later change
 * to the form's type does not reclassify existing responses.
 */
export const isNoteFormResponse = <T extends { isInternalNote?: boolean }>(response: T): boolean =>
  !!response.isInternalNote;
